import { format } from 'date-fns';

const parse = (item: any) =>
  Object.freeze({
    ...item,
    orderId: item!.id || '',
    status: item!.state || '',
    img:
      item.event && item.event.image && item.event.image.url
        ? {
            small: item.event.image.url,
          }
        : { small: '' },
    title: item.event && item.event.name ? item.event.name : '',
    date: item.date_created ? format(item.date_created, 'DD.MM.YYYY') : '',
    dates: {
      from: item.dates?.from ? format(item.dates.from, 'DD.MM.YYYY') : '',
      to: item.dates?.to ? format(item.dates.to, 'DD.MM.YYYY') : '',
    },
    schedule_dates: {
      from: item.schedule_dates?.from
        ? format(item.schedule_dates.from, 'DD.MM.YYYY')
        : '',
      to: item.schedule_dates?.to
        ? format(item.schedule_dates.to, 'DD.MM.YYYY')
        : '',
    },
    groupName: item.group_name ? item.group_name : '-',
    fio: item.student && item.student.fio ? item.student.fio : '',
    eventId: item!.event_id || '',
    userCanCancel: item.user_can_cancel,
    code: item.event && item.event.url_code ? item.event.url_code : '',
    id: item!.event_id || '',
    message:
      item.state_reason === '3' && item.state_reason_comment
        ? item.state_reason_comment
        : '',
  });

const ordersParse = (data: Array<any>) => data.map(parse);

export default ordersParse;



// WEBPACK FOOTER //
// ./src/services/orders/utils/ordersParse.ts